import { useMemo, useState } from "react";
import { displayAccountLabel } from "@common/helpers/accounting";
import { AccountRole } from "@common/types/domains/accounting/account";
import { ReassignRoleModalShell } from "@components/accounting/chartOfAccounts/ReassignRoleModalShell";
import { ReassignRoleTargetPicker } from "@components/accounting/chartOfAccounts/ReassignRoleTargetPicker";
import { RoleMappingAccount } from "../../roles/requiredAccountsMapping";

interface Props {
    show: boolean;
    role: AccountRole;
    targetAccounts: readonly RoleMappingAccount[];
    onReassign: (targetAccountId: string) => void;
    onHide: () => void;
    onExited: () => void;
}

export const TemplateReassignRoleModal = ({
    show,
    role,
    targetAccounts,
    onReassign,
    onHide,
    onExited,
}: Props) => {
    const [targetAccountId, setTargetAccountId] = useState<string | null>(null);
    const items = useMemo(
        () =>
            targetAccounts.map((account) => ({
                value: account.id,
                label: displayAccountLabel(
                    { name: account.name, codeText: account.codeText ?? null },
                    true,
                ),
            })),
        [targetAccounts],
    );

    return (
        <ReassignRoleModalShell
            show={show}
            onHide={onHide}
            onExited={onExited}
            role={role}
            isSubmitDisabled={targetAccountId === null}
            isSubmitting={false}
            onSubmit={() => {
                if (targetAccountId !== null) {
                    onReassign(targetAccountId);
                }
            }}
        >
            <ReassignRoleTargetPicker
                items={items}
                value={targetAccountId}
                emptyNoun="template"
                onChange={setTargetAccountId}
            />
        </ReassignRoleModalShell>
    );
};
